// const tittelBilde = "./img/00.png";
// const handlekurv = "https://www.paypal.com/cgi-bin/webscr?cmd=_cart&business=QKRS3GKHU65ZS&display=1";
const group1 = [
  {
    id: 1,
    tittel: "Sittende liten skarv med messingfarge",
    beskrivelse: "Sitter på stein, messingfarge, uten vinger, høyde (u/stein) ca. 9 cm ",
    pris1: "Kr. 800,-",
    pris2: false,
    pris3: false,
    ppid1: "ECV9Q7DNA965W",
    vippsId1: "8dux9x", // https://betal.vipps.no/8dux9x
    farge: "Messing",
    caroId: "10",
    caroId2: "#10",
    activeCaro: "./img/10.jpg",
    caro: [{ img: "./img/11.jpg" }, { img: "./img/12.jpg" }, { img: "./img/13.jpg" }, { img: "./img/14.jpg" }, { img: "./img/15.jpg" }],
  },
  {
    id: 2,
    tittel: "Sittende liten skarv i svart",
    beskrivelse: "Sittende på stein, svart, uten vinger, fuglens høyde (uten stein) ca. 9 cm",
    ppid1: "QUTY5L366J3Q8",
    vippsId1: "6to51h", // https://betal.vipps.no/6to51h
    pris1: "Kr. 800,-",
    pris2: false,
    pris3: false,
    farge: "Svart",
    caroId: "20",
    caroId2: "#20",
    activeCaro: "./img/20.jpg",
    caro: [{ img: "./img/21.jpg" }, { img: "./img/22.jpg" }, { img: "./img/23.jpg" }, { img: "./img/24.jpg" }, { img: "./img/25.jpg" }, { img: "./img/26.jpg" }],
  },
  {
    id: 3,
    tittel: "Stående liten skarv med messingfarge",
    beskrivelse: "Stående, messingfarge, uten vinger, høyde ca. 9 cm",
    ppid1: "ZAYDW64PVLSU6",
    vippsId1: "rw62s5", // https://betal.vipps.no/rw62s5
    pris1: "Kr. 890,-",
    pris2: false,
    pris3: false,
    farge: "Messing",
    caroId: "30",
    caroId2: "#30",
    activeCaro: "./img/30.jpg",
    caro: [{ img: "./img/31.jpg" }, { img: "./img/32.jpg" }, { img: "./img/33.jpg" }, { img: "./img/34.jpg" }, { img: "./img/35.jpg" }, { img: "./img/36.jpg" }],
  },
  {
    id: 4,
    tittel: "Stående liten skarv i svart",
    beskrivelse: "Stående, svart, uten vinger, fuglens høyde ca. 9 cm",
    ppid1: "TZVLJTW2BE6BN",
    vippsId1: "58hh0t", // https://betal.vipps.no/58hh0t
    pris1: "Kr. 890,-",
    pris2: false,
    pris3: false,
    farge: "Svart",
    caroId: "40",
    caroId2: "#40",
    activeCaro: "./img/40.jpg",
    caro: [{ img: "./img/41.jpg" }, { img: "./img/42.jpg" }, { img: "./img/43.jpg" }, { img: "./img/44.jpg" }],
  },
  {
    id: 5,
    tittel: "Mellomstor skarv med messingfarge",
    beskrivelse: "Messingfarge, sittende på stein, utslåtte vinger, høyde (uten stein) ca. 12 cm, bredde ca. 20 cm",
    ppid1: "JSJDET25HJFSS",
    vippsId1: "816xrt", // https://betal.vipps.no/816xrt
    pris1: "Kr. 1595,-",
    pris2: false,
    pris3: false,
    farge: "Messing",
    caroId: "50",
    caroId2: "#50",
    activeCaro: "./img/50.jpg",
    caro: [{ img: "./img/51.jpg" }, { img: "./img/52.jpg" }, { img: "./img/53.jpg" }],
  },
  {
    id: 6,
    tittel: "Mellomstor skarv i svart",
    beskrivelse: "Svartfarget, sittende på stein, utslåtte vinger, høyde (uten stein) ca. 12 cm, bredde ca. 20 cm",
    ppid1: "E9T8WZKFQNFNW",
    vippsId1: "emfs72", // https://betal.vipps.no/emfs72
    pris1: "Kr. 1595,-",
    pris2: false,
    pris3: false,
    farge: "Svart",
    caroId: "60",
    caroId2: "#60",
    activeCaro: "./img/60.jpg",
    caro: [{ img: "./img/61.jpg" }, { img: "./img/62.jpg" }, { img: "./img/63.jpg" }],
  },
  {
    id: 7,
    tittel: "Stående storskarv med messingfarge",
    beskrivelse: "Messingfarge, stående på stein, utslåtte vinger",
    ppid1: "QKM86PCL3KZFC",
    ppid2: "BF25PZER5A5HU",
    ppid3: "BL2DS5KZM67ZQ",
    vippsId1: "scxeyg", // https://betal.vipps.no/scxeyg
    vippsId2: "r0hscz", // https://betal.vipps.no/r0hscz
    vippsId3: "q80tik", // https://betal.vipps.no/q80tik
    pris1: "Kr. 2860,-",
    pris2: "Kr. 3300,-",
    pris3: "Kr. 4510,-",
    farge: "Messing",
    caroId: "70",
    caroId2: "#70",
    activeCaro: "./img/70.jpg",
    caro: [{ img: "./img/71.jpg" }, { img: "./img/72.jpg" }, { img: "./img/73.jpg" }, { img: "./img/74.jpg" }, { img: "./img/75.jpg" }],
  },
  {
    id: 8,
    tittel: "Stående storskarv i svart",
    beskrivelse: "Svartfarget, stående på stein, utslåtte vinger",
    ppid1: "GLRZ8UJDDNDMN",
    ppid2: "R6PGNS8WUFDUQ",
    ppid3: "SANGC24J9YS7U",

    vippsId1: "ht0r4b", // https://betal.vipps.no/ht0r4b
    vippsId2: "s89cie", // https://betal.vipps.no/s89cie
    vippsId3: "e6e8nu", // https://betal.vipps.no/e6e8nu

    pris1: "Kr. 2860,-",
    pris2: "Kr. 3300,-",
    pris3: "Kr. 4510,-",
    farge: "Svart",
    caroId: "80",
    caroId2: "#80",
    activeCaro: "./img/80.jpg",
    caro: [{ img: "./img/81.jpg" }, { img: "./img/82.jpg" }, { img: "./img/83.jpg" }, { img: "./img/84.jpg" }, { img: "./img/85.jpg" }],
  },
  {
    id: 9,
    tittel: "Kongeskarv med messingfarge",
    ppid1: "NGTP8S4ACTCQ8",
    vippsId1: "dh2x8v", // https://betal.vipps.no/dh2x8v
    beskrivelse: "Messingfarge, stående på stein utslåtte vinger, vingespenn 60 cm, høyde uten stein ca. 38 cm.",
    pris1: "Kr. 6930,-",
    pris2: false,
    pris3: false,
    farge: "Messing",
    caroId: "90",
    caroId2: "#90",
    activeCaro: "./img/90.jpg",
    caro: [{ img: "./img/91.jpg" }, { img: "./img/92.jpg" }, { img: "./img/93.jpg" }, { img: "./img/94.jpg" }, { img: "./img/95.jpg" }, { img: "./img/96.jpg" }],
  },
  {
    id: 10,
    tittel: "Svart kongeskarv",
    beskrivelse: "Svart, stående på stein utslåtte vinger, vingespenn 60 cm, høyde uten stein ca. 38 cm.",
    ppid1: "KFBL37VBPQRYE",
    vippsId1: "rppkuv", // https://betal.vipps.no/rppkuv
    pris1: "Kr. 6930,-",
    pris2: false,
    pris3: false,
    farge: "Svart",
    caroId: "100",
    caroId2: "#100",
    activeCaro: "./img/100.jpg",
    caro: [{ img: "./img/101.jpg" }, { img: "./img/102.jpg" }, { img: "./img/103.jpg" }, { img: "./img/104.jpg" }],
  },
  {
    id: 11,
    tittel: "Pingvin",
    beskrivelse: "Stående, messingfarge, høyde ca. 14 cm",
    // ppid1: '5NWH764TCE6KY',
    ppid1: "GYZ72MS82PNL6",
    vippsId1: "fvsb9a", // https://betal.vipps.no/fvsb9a
    ppid2: false,
    pris1: "Kr. 1045,-",
    pris2: false,
    // pris2: 'Kr. 780,-',
    pris3: false,
    farge: "Messing",
    caroId: "110",
    caroId2: "#110",
    activeCaro: "./img/110.jpg",
    caro: [{ img: "./img/111.jpg" }, { img: "./img/112.jpg" }, { img: "./img/113.jpg" }, { img: "./img/114.jpg" }, { img: "./img/115.jpg" }, { img: "./img/116.jpg" }, { img: "./img/117.jpg" }],
  },
  {
    id: 12,
    tittel: "Ørn Med Fisk",
    beskrivelse: "Messingfarge, vingespenn ca 37 cm",
    ppid1: "JQ86SV5V7ZBGU",
    vippsId1: "6587cz", // https://betal.vipps.no/6587cz
    pris1: "Kr. 4950,-",
    pris2: false,
    pris3: false,
    farge: "Messing",
    caroId: "120",
    caroId2: "#120",
    activeCaro: "./img/120.jpg",
    caro: [{ img: "./img/121.jpg" }, { img: "./img/122.jpg" }, { img: "./img/123.jpg" }, { img: "./img/124.jpg" }, { img: "./img/125.jpg" }],
  },
];

export default group1;
